import './global.js';

const checkArticleImage = () => {
    let articleImage = document.querySelector('.article-head-left img');
    let articleRight = document.querySelector('.article-head-right');
    if (!articleImage) {
        articleRight.classList.add('no-image');
    }
}
checkArticleImage();

